export default __webpack_public_path__ + "static/media/atom-i-link.5ba103aa.svg";